import {
  inject,
  Injectable,
} from "@angular/core";

import {
  HttpClient,
} from "@angular/common/http";

import {
  Observable,
} from "rxjs";

import {
  BBPS_SupportTicket_Create,
  BBPS_SupportTicket_Delete,
  BBPS_SupportTicket_ReadAll,
  BBPS_SupportTicket_ReadByAssignedTo,
  BBPS_SupportTicket_ReadById,
  BBPS_SupportTicket_ReadByTicketNo,
  BBPS_SupportTicket_ReadByUserId,
  BBPS_SupportTicket_Update,
  BBPS_SupportTicket_ReadAllPaginated
} from "src/app/GlobalVariable";

import {
  SupportTicketCreateRequestDTO,
  SupportTicketDeleteRequestDTO,
  SupportTicketDeleteResponseDTO,
  SupportTicketDTO,
  SupportTicketList,
  SupportTicketReadByAssignedToRequestDTO,
  SupportTicketReadByIdRequestDTO,
  SupportTicketReadByTicketNoRequestDTO,
  SupportTicketReadByUserIdRequestDTO,
  SupportTicketUpdateRequestDTO,
  SupportTicketReadAllPaginatedRequestDTO
} from "./support-ticket.interface";

@Injectable({
  providedIn: "root",
})
export class SupportTicketService {
  private readonly http =
    inject(HttpClient);

  /**
   * POST /BBPS/ST/Create
   */
  SupportTicket_Create(
    data: SupportTicketCreateRequestDTO,
  ): Observable<SupportTicketDTO> {
    return this.http.post<SupportTicketDTO>(
      BBPS_SupportTicket_Create,
      data,
    );
  }

  /**
   * POST /BBPS/ST/Update
   */
  SupportTicket_Update(
    data: SupportTicketUpdateRequestDTO,
  ): Observable<SupportTicketDTO> {
    return this.http.post<SupportTicketDTO>(
      BBPS_SupportTicket_Update,
      data,
    );
  }

  /**
   * POST /BBPS/ST/Delete
   */
  SupportTicket_Delete(
    data: SupportTicketDeleteRequestDTO,
  ): Observable<SupportTicketDeleteResponseDTO> {
    return this.http.post<SupportTicketDeleteResponseDTO>(
      BBPS_SupportTicket_Delete,
      data,
    );
  }

  /**
   * GET /BBPS/ST/ReadAll
   */
  SupportTicket_ReadAll(): Observable<SupportTicketList> {
    return this.http.get<SupportTicketList>(
      BBPS_SupportTicket_ReadAll,
    );
  }

  /**
   * POST /BBPS/ST/ReadById
   */
  SupportTicket_ReadById(
    data: SupportTicketReadByIdRequestDTO,
  ): Observable<SupportTicketDTO> {
    return this.http.post<SupportTicketDTO>(
      BBPS_SupportTicket_ReadById,
      data,
    );
  }

  /**
   * POST /BBPS/ST/ReadByTicketNo
   */
  SupportTicket_ReadByTicketNo(
    data: SupportTicketReadByTicketNoRequestDTO,
  ): Observable<SupportTicketDTO> {
    return this.http.post<SupportTicketDTO>(
      BBPS_SupportTicket_ReadByTicketNo,
      data,
    );
  }

  /**
   * POST /BBPS/ST/ReadByUserId
   */
  SupportTicket_ReadByUserId(
    data: SupportTicketReadByUserIdRequestDTO,
  ): Observable<SupportTicketList> {
    return this.http.post<SupportTicketList>(
      BBPS_SupportTicket_ReadByUserId,
      data,
    );
  }

  /**
   * POST /BBPS/ST/ReadByAssignedTo
   */
  SupportTicket_ReadByAssignedTo(
    data: SupportTicketReadByAssignedToRequestDTO,
  ): Observable<SupportTicketList> {
    return this.http.post<SupportTicketList>(
      BBPS_SupportTicket_ReadByAssignedTo,
      data,
    );
  }

  SupportTicket_ReadAllPaginated(
  data: SupportTicketReadAllPaginatedRequestDTO
): Observable<SupportTicketList> {
  return this.http.post<SupportTicketList>(
    BBPS_SupportTicket_ReadAllPaginated,
    data
  );
}
}